export const SERVICE_WORKER_UPDATE_CHECK_INTERVAL_MS = 15 * 60 * 1000;
export const SERVICE_WORKER_UPDATE_CHECK_MIN_INTERVAL_MS = 60 * 1000;
export const STARTUP_UPDATE_GRACE_MS = 10 * 1000;

export const AUTO_RELOAD_HIDDEN_DELAY_MS = 2 * 60 * 1000;
export const AUTO_RELOAD_IDLE_DELAY_MS = 15 * 60 * 1000;
export const AUTO_RELOAD_POLL_INTERVAL_MS = 10 * 1000;
export const AUTO_RELOAD_MAX_PER_SESSION = 3;
export const AUTO_RELOAD_COUNT_STORAGE_KEY = "medibase-auto-reload-count";

export const POSTPONE_DURATION_MS = 2 * 60 * 60 * 1000;
export const SKIP_WAITING_TIMEOUT_MS = 5 * 1000;
export const PENDING_WRITES_FLUSH_TIMEOUT_MS = 2 * 1000;
